<template>
  <faqs use-filter :audiences="[0,2]"></faqs>
</template>

<script>
import Faqs from "@components/shared/Faqs";
export default {
  name: "FaqsInvestors",
  components: {
    Faqs
  }
}
</script>

<style scoped>

</style>